import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { getLocationInfoFromSites, filterSitesByActiveRecruitment } from '../../../utils';
import ResultsListItem from './ResultsListItem';
import './ResultsList.scss';
import { FilterContext } from '../../../features/filters/context/FilterContext/FilterContext';

import { isWithinRadius } from '../../../utils/isWithinRadius';

const ResultsList = ({ results, resultsItemTitleLink, totalResults }) => {
	// Only use filters if we're within a FilterProvider context (not on Manual pages)
	let appliedFilters = {};
	let appliedZipCoords = null;
	let zipRadius = null;

	// Check if we're in a FilterProvider context using useContext directly
	const filterContext = useContext(FilterContext);

	if (filterContext) {
		// We're within FilterProvider context
		const { state, appliedZipCoords: coords } = filterContext;
		appliedFilters = state.appliedFilters;
		appliedZipCoords = coords;
		zipRadius = appliedFilters.location?.radius;
	}
	var hasZipInput = false;
	var zipInputReturn = '';

	function displayLocation(sitesList, zipCoords, zipRadius) {
		// Filter sites by active recruitment status before counting nearby sites
		const activeSites = filterSitesByActiveRecruitment(sitesList);

		const countNearbySitesByZip = (arr) => {
			return arr.reduce((count, itemSite) => count + isWithinRadius(zipCoords, itemSite.org_coordinates, zipRadius), 0);
		};

		zipInputReturn = `, including ${countNearbySitesByZip(activeSites)} near you`;
	}

	return (
		<div className="ctla-results__list grid-container">
			<div className="grid-row">
				<div className="grid-col">
					{appliedFilters.length > 0 && (
						<div className="ctla-results__filters-summary">
							Showing results for:
							{appliedFilters.map((filter) => (
								<span key={filter.type} className="ctla-results__filter-tag">
									{filter.label}
								</span>
							))}
						</div>
					)}
					<ul>
						{results.map((resultItem, index) => {
							const { brief_title, current_trial_status, nci_id, nct_id, sites } = resultItem;

							if (appliedZipCoords !== null) {
								hasZipInput = true;
								zipRadius = appliedFilters.location?.radius;

								displayLocation(sites, appliedZipCoords, zipRadius, hasZipInput);
							}

							const locationInfo = getLocationInfoFromSites(current_trial_status, nct_id, sites, hasZipInput, zipInputReturn);

							return <ResultsListItem key={nci_id} locationInfo={locationInfo} nciId={nci_id} status={current_trial_status} title={brief_title} resultsItemTitleLink={resultsItemTitleLink} resultIndex={index} totalResults={totalResults} />;
						})}
					</ul>
				</div>
			</div>
		</div>
	);
};

ResultsList.propTypes = {
	results: PropTypes.arrayOf(
		PropTypes.shape({
			brief_summary: PropTypes.string,
			brief_title: PropTypes.string,
			current_trial_status: PropTypes.string,
			nci_id: PropTypes.string,
			nct_id: PropTypes.string,
			sites: PropTypes.array,
		})
	).isRequired,
	resultsItemTitleLink: PropTypes.string.isRequired,
	appliedFilters: PropTypes.array,
	totalResults: PropTypes.number,
};

export default ResultsList;
